import React, { ComponentProps, FC } from "react";
import { cn } from "@/lib";
import { CustomButton, FlexBetween } from "./ui";
import { BdAltArrowLeft } from "solar-icon-react/bd";
import Link from "next/link";
import { routes } from "@/routes";

interface Props extends ComponentProps<"div"> {
  description: string;
  buttonlabel: string;
}

const CoreServicesIntroBox: FC<Props> = ({ ...props }) => {
  return (
    <div
      {...props}
      className={cn(
        "border-custom-main-light shadow-main mx-auto w-full rounded-xl border px-8 py-6 sm:px-10",
        props.className,
      )}
    >
      <FlexBetween
        gap={12}
        className={cn("mx-auto w-full flex-col gap-6 lg:flex-row")}
      >
        <p className="lg:textyarn -lg font-normal sm:text-sm md:max-w-[600px] xl:max-w-[800px] xl:text-xl">
          {props.description}
        </p>
        <Link
          id="show-all-services-core"
          href={routes.main.SERVICES.primaryPath}
        >
          <CustomButton
            className={cn("mx-auto w-max px-6! xl:px-8!")}
            variant="primary"
            iconPosition="end"
            icon={<BdAltArrowLeft size={25} />}
          >
            {props.buttonlabel}
          </CustomButton>
        </Link>
      </FlexBetween>
    </div>
  );
};

export default CoreServicesIntroBox;
